<template>
  <v-container>
    <v-row justify="space-between" dense>
      <v-row align="start" justify="center">
        <v-col cols="12">
          <v-card class="elevation-2">
            <title-bar-home></title-bar-home>
            <v-row>
              <v-col class="text-center">
                <h1 class="custom-h1">Apply to Dutch Bros</h1>
              </v-col>
            </v-row>
            <v-row justify="space-between" dense>
              <v-col cols="12" md="6">
                <v-card
                  height="700px"
                  class="mx-auto"
                  outlined
                  style="overflow: scroll"
                >
                  <v-toolbar color="primary" dark flat
                    >Select Location(s)</v-toolbar
                  >

                  <v-toolbar class="my-1 pt-4">
                    <v-text-field
                      v-model="location"
                      label="ZIP Code / Location"
                      outlined
                      dense
                      @keydown.enter="show"
                    >
                      <template v-slot:append>
                        <v-btn
                          v-if="location != set_location"
                          color="primary"
                          @click="show"
                          style="height: 24px"
                          >show</v-btn
                        >
                      </template>
                    </v-text-field>
                  </v-toolbar>

                  <v-toolbar v-if="locations.length > 0">
                    <v-btn
                      block
                      :loading="sending"
                      :disabled="sending"
                      color="primary"
                      class="white--text px-2"
                      @click="formSubmit"
                    >
                      Start Application ({{ locations.length }} Location<span
                        v-if="locations.length > 1"
                        >s</span
                      >)
                      <v-icon right dark class="hidden-sm-and-down"
                        >mdi-cloud-upload</v-icon
                      >
                    </v-btn>
                  </v-toolbar>

                  <v-card class="px-4 py-4" v-if="locations.length === 0">
                    Please select one or more Dutch Bros locations to send your
                    application.
                  </v-card>

                  <v-card
                    class="mx-auto mb-3"
                    v-for="(shop, index) in shops"
                    :key="index"
                    v-bind:class="{
                      'shop--selected': locations.includes(shop.new_co_id),
                    }"
                  >
                    <v-row justify="start" dense>
                      <v-col cols="12">
                        <v-checkbox
                          class="pl-3"
                          v-model="locations"
                          aria-label
                          :value="shop.new_co_id"
                          dense
                          :label="
                            shop.stand_address +
                            ', ' +
                            shop.city +
                            ', ' +
                            shop.state +
                            ', ' +
                            shop.zip_code
                          "
                          :disabled="!shop.is_hiring"
                          v-if="
                            !(
                              shop.is_hiring === true &&
                              shop.workday_url !== null
                            )
                          "
                        />
                        <div
                          v-else
                          class="pl-3 my-3"
                          style="color: rgba(0, 0, 0, 0.6)"
                        >
                          {{ shop.stand_address }}, {{ shop.city }},
                          {{ shop.state }}, {{ shop.zip_code }}
                        </div>
                        <v-alert
                          dense
                          class="mt-0 mb-3 mx-3"
                          outlined
                          color="warning"
                          v-if="shop.is_hiring === false"
                        >
                          Not currently accepting applications
                        </v-alert>
                        <v-alert
                          dense
                          class="mt-0 mb-3 mx-3"
                          outlined
                          color="info"
                          v-if="
                            shop.is_hiring === true && shop.workday_url !== null
                          "
                        >
                          Apply to this location
                          <strong
                            ><a :href="shop.workday_url" target="_blank"
                              >here</a
                            ></strong
                          >
                        </v-alert>
                      </v-col>
                      <!-- <v-col cols="10">
                        {{ shop.store_nickname }}
                        <br />
                        {{
                        shop.stand_address
                        }}
                        {{ shop.city }}, {{ shop.state }}
                        {{ shop.zip_code }}
                      </v-col>-->
                    </v-row>
                  </v-card>
                </v-card>
              </v-col>

              <v-col cols="12" md="6" style="height: 700px; overflow: hidden">
                <v-card style="width: 100%; height: 100%">
                  <MglMap
                    :accessToken="accessToken"
                    :mapStyle.sync="mapStyle"
                    :center="coordinates"
                    :zoom="zoom"
                    ref="mapboxMap"
                  >
                    <MglMarker
                      @click="go_to()"
                      v-for="(shop, index) in shops"
                      :key="index"
                      :coordinates="[shop.lon, shop.lat]"
                      class="marker"
                      anchor="bottom"
                    >
                      <v-icon
                        slot="marker"
                        class="marker"
                        style="position: absolute; transition: none !important"
                        v-if="shop.is_hiring === true"
                      ></v-icon>
                      <v-icon
                        slot="marker"
                        class="grey-marker marker"
                        style="position: absolute; transition: none !important"
                        v-if="shop.is_hiring === false"
                      ></v-icon>
                      <MglPopup>
                        <v-card flat>
                          <h3>{{ shop.store_nickname }}</h3>
                          <v-btn
                            color="primary"
                            block
                            @click="add_location(shop)"
                            v-if="shop.is_hiring === true"
                            >Apply Here</v-btn
                          >
                          <v-alert
                            dense
                            outlined
                            color="warning"
                            v-if="shop.is_hiring === false"
                          >
                            Not currently accepting applications
                          </v-alert>
                        </v-card>
                      </MglPopup>
                    </MglMarker>
                  </MglMap>
                </v-card>
              </v-col>
            </v-row>
            <v-footer color="white" class="py-3">
              <v-btn
                v-if="locations.length > 0"
                block
                :loading="sending"
                :disabled="sending"
                color="primary"
                class="white--text px-0"
                @click="formSubmit"
              >
                Start Application ({{ locations.length }} Location<span
                  v-if="locations.length > 1"
                  >s</span
                >)
                <v-icon right dark class="hidden-sm-and-down"
                  >mdi-cloud-upload</v-icon
                >
              </v-btn>
            </v-footer>
            <footer-bar></footer-bar>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<style scoped>
.marker {
  background-image: url(https://files.dutchbros.com/icons/stand-location-icon__white.png);
}
.grey-marker {
  background-image: url(https://files.dutchbros.com/icons/stand-location-icon__grey.png);
}
.marker,
.marker--future {
  border: none;
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.shop--selected {
  background-color: rgb(252, 255, 208) !important;
  transition: transform 1s;
}
</style>

<script>
import TitleBarHome from "../components/TitleBarHome";
import FooterBar from "../components/Footer";
import Mapbox from "mapbox-gl";
import { MglMap, MglMarker, MglPopup } from "vue-mapbox";
import axios from "axios";
import validUrl from "valid-url";

export default {
  components: {
    MglMap,
    MglMarker,
    MglPopup,
    TitleBarHome,
    FooterBar,
  },
  computed: {
    location: {
      get() {
        return this.$store.state.location;
      },
      set(value) {
        this.$store.commit("setLocation", { location: value });
      },
    },
    locations: {
      get() {
        return this.$store.state.locations;
      },
      set(value) {
        this.$store.commit("setLocations", { locations: value });
      },
    },
    signals: {
      get() {
        return this.$store.state.signals;
      },
      set(value) {
        this.$store.commit("setSignals", { signals: value });
      },
    },
    app_state: {
      get() {
        return this.$store.state;
      },
    },
  },

  data() {
    return {
      loading: true,
      set_location: "",
      signalsUrl: process.env.VUE_APP_SIGNALS_API,
      // signalsUrl: "https://portal.dutchbros.com/employee_change/hiring/signals",
      // apiUrl: "https://files.dutchbros.com/api-cache/stands.json",
      accessToken:
        "pk.eyJ1IjoiZGJ3ZWJkZXYiLCJhIjoiY2sya3FlNGRyMXBrYzNtcGhkdGttb2d3eSJ9.ikPWqxG9YV_-gY7q6qTTdA",
      mapStyle: "mapbox://styles/dbwebdev/ck9btlpgc0d0m1irv1hesf09o",
      coordinates: [-123.33235, 42.4342182],
      zoom: 10,
      shops: [],
      selected: [],
      sending: false,
    };
  },
  mounted() {
    this.$refs.mapboxMap.$on('load', () => {
      this.setupEventListeners();
    });
  },
  created() {
    this.mapbox = Mapbox;
    this.show();
    this.loading = false;
  },

  methods: {
    log: function (details) {
      console.log(details);
    },
    go_to: function () {},
    show: function () {
      this.loading = true;
      if (this.location && this.location != this.set_location)
        this.get_signals(encodeURIComponent(this.location));
      else this.get_signals();
      this.loading = false;
    },
    add_location: function (shop) {
      if (validUrl.isUri(shop.workday_url)) {
        window.location = shop.workday_url;
        return;
      }
      if (!this.locations.includes(shop.new_co_id))
        this.locations.push(shop.new_co_id);
    },
    get_signals: function (local_str = "") {
      let signalsUrl = this.signalsUrl;
      if (local_str) signalsUrl = signalsUrl + "/" + local_str;
      axios
        .get(signalsUrl)
        .then((response) => {
          this.locations = [];
          this.signals = response.data;
          if (!this.location)
            this.location = `${response.data.signals.city}, ${response.data.signals.region}`;
          this.set_location = this.location;
          this.shops = response.data.shops;
          this.coordinates = [
            response.data.signals.longitude,
            response.data.signals.latitude,
          ];
          // console.log(this.locations);
        })
        .catch((error) => {
          console.log("There was an error:", error.response);
        });
    },
    formSubmit(e) {
      e.preventDefault();
      this.$router.push({ name: "P1" });
    },
    setupEventListeners: function () {
      this.$refs.mapboxMap.map.on('zoomend', this.refreshMarkers);
    },
    refreshMarkers: function () {
      this.$refs.mapboxMap.map.resize();
    },
  },
};
</script>
